module.exports = __webpack_public_path__ + "img/t2.aa02107f.png";